module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921084149_T.073cfd4c.jpg";